// src/lib/invoice-preview.js — Chantier C (numéro réel PRÉVU dans l'aperçu facture)
// Helper PUR (zéro I/O) pour calculer le PROCHAIN numéro de facture PRÉVU à
// afficher dans l'aperçu voyageur (lecture seule — JAMAIS consommé en DB).
//
// La sélection lit `next_number` de la série (prefix, year) correspondante,
// renvoyée par getInvoiceSequences (api/beds24-mapping?action=getInvoiceSequences).
// On ne lit JAMAIS `max_emitted` : ce dernier diverge de la RPC nextInvoiceNumber
// (qui s'appuie sur last_number+1 via row-lock). next_number = last_number + 1,
// strictement cohérent avec ce que produira l'émission réelle.
// NB compteur DYNAMIQUE : next_number n'est plus monotone (last_number redescend
// après une suppression via resync_invoice_sequence). L'aperçu reflète donc le
// prochain numéro réellement prévu à l'instant T — toujours = ce qu'émettra la RPC.
//
// Le numéro renvoyé est PURELY indicatif : aucune émission, aucune écriture. La
// mention « (aperçu) » est posée par le générateur HTML, pas ici.

// computePreviewNumber({ prefix, year, sequences })
//   → `${prefix}-${year}-${LPAD(next_number, 4)}` si la série (prefix, year)
//     existe dans `sequences` ;
//   → null sinon (série absente OU prefix/year manquant) → l'appelant retombe
//     sur le fallback XXXX du générateur.
export function computePreviewNumber({ prefix, year, sequences } = {}) {
  if (!prefix || !year || !Array.isArray(sequences)) return null
  const match = sequences.find(
    (s) => s && s.prefix === prefix && s.year === year,
  )
  if (!match) return null
  const n = Number(match.next_number)
  if (!Number.isFinite(n) || n < 1) return null
  return `${prefix}-${year}-${String(n).padStart(4, '0')}`
}
